export default __webpack_public_path__ + "static/media/icon-employees.03fae008.svg";